import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../utils/api';
import './Gallery.css';

function Gallery({ projects }) {
  const navigate = useNavigate();

  const handleClick = (slug) => {
    navigate(`/project/${slug}`);
  };

  if (!projects || projects.length === 0) {
    return (
      <div className="gallery-empty">
        <p>No projects found.</p>
      </div>
    );
  }

  return (
    <div className="gallery">
      {projects.map((project) => (
        <div 
          key={project.slug} 
          className="gallery-item"
          onClick={() => handleClick(project.slug)}
        >
          <div className="gallery-image-container">
            <img 
              src={getImageUrl(project.imageUrl)}
              alt={project.title}
              className="gallery-image"
            />
          </div>
          <div className="gallery-title">{project.title}</div>
        </div>
      ))}
    </div>
  );
}

export default Gallery;
